import FloatingHeaderContainer from './FloatingHeaderContainer';

export default FloatingHeaderContainer;